module.exports = __webpack_public_path__ + "img/daichao1.6d8450c2.png";